import { Card } from "../../components/Card"
import KpiComponent from "../../components/KpiCards"

export const ProjectDashScreen = ({ dw, formattDw, assistanceDw }) => {
  return <>
    {formattDw && dw && <Card>
      <KpiComponent
        title="Número de produtores por setor"
        subtitle={`Total de produtores no projeto: ${formattDw[0]?.totalProducers || 0}`}
        indicators={formattDw}
        data={dw}
      />
    </Card>
    }
    {assistanceDw && dw && <Card>
      <KpiComponent
        title="Registro de conteúdos"
        subtitle={`Total de produtores no projeto: ${formattDw[0]?.totalProducers || 0}`}
        indicators={assistanceDw}
        data={dw}
      />
    </Card>
    }
  </>
}